import { render, staticRenderFns } from "./Adminadress.vue?vue&type=template&id=00a60c76&scoped=true"
import script from "./Adminadress.vue?vue&type=script&lang=js"
export * from "./Adminadress.vue?vue&type=script&lang=js"
import style0 from "./Adminadress.vue?vue&type=style&index=0&id=00a60c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a60c76",
  null
  
)

export default component.exports